/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import QRCode from "qrcode.react";
import { getQueryString } from "../../util/getQueryString";
import { useEffect, useState } from "react";

export default function WithDownload() {
  const advisorId: string = getQueryString("advisorId") || "";
  const source: string = getQueryString("source") || "";
  const [url, setUrl] = useState<string>("");
  useEffect(() => {
    setUrl(
      `https://mobile.react.tysoft.com/registerWithDownload?advisorId=${advisorId}&source=${source}`
    );
  }, [advisorId, source]);
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          height: "100vh",
          alignItems: "center",
        }}
      >
        <QRCode
          value={url}
          size={200}
          imageSettings={{
            src: "/logo1.png",
            height: 30,
            width: 30,
            excavate: true,
          }}
        />
      </div>
    </>
  );
}
